
export default {
    install(Vue) {
        Vue.prototype.getImg = function (img) {
            if (img && img.indexOf("assets") > -1) {
                img = img.split("assets")[1];
                return require("@/assets" + img);
            } else {
                return img;
            }
        }

        Vue.prototype.setFontsize = function (size, spacing = 8) {//标题字号及行间距定制化
            if (size) {
                return `fontSize:${size}px;letter-spacing: ${spacing || 8}px;font-family: MSSB;`
            } else {
                return 'fontSize:28px;letter-spacing: 8px;font-family: MSSB;'
            }
        }
        Vue.prototype.tipData = function (config, indexList = []) {//数字翻页器溢出元素弹框显示
            let data = []
            if (indexList.length) {
                data = config?.data || config
                data.forEach(item => {
                    indexList.forEach(i => {
                        item[i] = `<div title="${item[i]}">${item[i]}</div>`
                    })
                })
            }
            else {
                data = config?.data || config
                data.forEach((item) => {
                    for (var i = 0; i < item.length; i++) {
                        item[i] = `<div title="${item[i]}">${item[i]}</div>`
                    }
                })
            }
            return config
        }
        Vue.directive('btnLimit', {
            inserted(button) {
                // 事件监听
                button.addEventListener('click', () => {
                    let text = button.innerText
                    button.setAttribute("disabled", true);
                    button.classList.add('is-disabled')
                    button.innerText = "请稍后..."
                    setTimeout(() => {
                        button.removeAttribute("disabled")
                        button.classList.remove('is-disabled')
                        button.innerText = text
                    }, 3000)
                })
            }
        })
        /**
             限制输入为正整数/^(0|[1-9][0-9]*)$/,类型为字符串
           **/
        Vue.directive('numLimit', {
            inserted(el, binding, vnode) {
                let element
                if (el.tagName != "INPUT") {
                    element = el.children[0]
                } else {
                    element = el
                }
                element.onblur = function () {
                    if (!(/^(0|[1-9][0-9]*)$/.test(el.children[0].value))) {
                        el.children[0].value = ''
                    }
                }
            }
        })


        /**
         限制输入为小数/^[0-9]+([.]{1}[0-9]+){0,1}$/ ,类型为字符串
       **/
        Vue.directive('decLimit', {
            inserted(el, binding, vnode) {
                let element
                if (el.tagName != "INPUT") {
                    element = el.children[0]
                } else {
                    element = el
                }
                element.onblur = function () {
                    let Bool = (/^\d+(\.\d+)?$/.test(el.children[0].value))
                    if (!Bool) {
                        el.children[0].value = ''
                    }
                }
            }
        })

        // Vue.directive('drag',{  
        //     bind(el){
        //         el.onmousedown = function (e) {
        //             let disX = e.clientX - el.offsetLeft;
        //             let disY = e.clientY - el.offsetTop;
        //             document.onmousemove = function (e) {
        //                 el.style.left = e.clientX - disX + "px";
        //                 el.style.top = e.clientY - disY + "px";
        //             };
        //             document.onmouseup = function () {
        //                 document.onmousemove = null;
        //             };
        //             return false;
        //         }
        //     }
        // })
        // Vue.directive('drag', {
        //     bind(el, binding) {
        //         el.onmousedown = (ev)=> {
        //             let oEvent = ev || window.event
        //             oEvent.stopPropagation();
        //             console.log(el)
        //             /* 
        //                 一、clientX、clientY
        //                 点击位置距离当前body可视区域的x，y坐标

        //                 二、pageX、pageY
        //                 对于整个页面来说，包括了被卷去的body部分的长度

        //                 三、screenX、screenY
        //                 点击位置距离当前电脑屏幕的x，y坐标

        //                 四、offsetX、offsetY
        //                 相对于带有定位的父盒子的x，y坐标
        //              */
        //             // clientX
        //             // clientWidth = width+左右padding
        //             // offsetWidth  offsetWidth = width + 左右padding + 左右boder
        //             // offsetLeft   元素本身到浏览器内侧的距离
        //             // 当前元素 上边框 外边缘 到 最近的已定位父级（offsetParent） 上边框 内边缘的 距离。如果父
        //             // 级都没有定位，则分别是到body 顶部 和左边的距离
        //             // let obj = document.getElementsByClassName("active")[0];
        //             let disX1 = oEvent.clientX - el.offsetLeft;
        //             let disY1 = oEvent.clientY - el.offsetTop;
        //             document.onmousemove = (ev)=> {
        //                 let oEvent = ev || window.event
        //                 let l = oEvent.clientX - disX1;
        //                 let t = oEvent.clientY - disY1;
        //                 if (binding.modifiers.limit) {
        //                     if (l < 0) {
        //                         l = 0;
        //                     }
        //                     if (l > document.documentElement.clientWidth - el.offsetWidth) {
        //                         l = document.documentElement.clientWidth - el.offsetWidth
        //                     }
        //                     if (t < 0) {
        //                         t = 0
        //                     }
        //                     if (t > document.documentElement.clientHeight - el.offsetWidth) {
        //                         t = document.documentElement.clientHeight - el.offsetWidth
        //                     }
        //                 }
        //                 el.style.left = l + 'px';
        //                 el.style.top = t + 'px';
        //             };
        //             document.onmouseup = function () {
        //                 document.onmousemove = null;
        //                 document.onmouseup = null;
        //             };
        //             return false;
        //         };
        //     }
        // })
    }

}